export const addPropertyFactory =
  <Key extends PropertyKey, V extends {}>(key: Key, value: V) =>
  <T>(opts: T): T & { [k in Key]: V } =>
    <any>{
      ...opts,
      [<any>key]: value,
    };
